// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Toastify__toast-body {
    white-space: pre-line;
}

/*
main {
    grid-area: main;
    max-width: 100%;
    overflow: hidden;
}
*/
button {
    background-color: #366ba0;
    color: white;
    padding: .375rem .75rem;
    border: 1px solid transparent;
    display: inline-block;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

button:hover {
    background-color: #2b5580;
    border-color: #2b5580;
}

select {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    margin-bottom: 1rem;
}

/*input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    box-sizing: border-box;
    margin-bottom: 1rem;
}*/

label select,input {
    margin-top: 0.5rem;
}
label {
    display: inline-block;
    margin-bottom: 0.5rem;
}

table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-spacing: 0;
}

table tbody tr:hover {
    color: #212529;
    background-color: rgba(0,0,0,.075);
}

table td:not(.expanded), table th:not(.search) {
    padding: .75rem;
    vertical-align: top;
    text-align: left;
}

.table-header {
    display: table-cell;
}

.change-type-selector {
    margin-bottom: 1rem;
}

.editor {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
}

.editor .CodeMirror {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.editor .CodeMirror pre.CodeMirror-line {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.launchnotes-widget .announcement-card-wrapper .announcement-card .categories {
  line-height: 0.5;
}

.loader {
    text-align: center;
    transition: width 2s;
}

.loader.button {
    display: inline;
    padding-left: 18px;
    padding-right: 18px;
}

.loader:not(.button) {
    font-size: 62px;
    color: #366ba0;
}

.loader i {
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loader-page {
    position: fixed;
    width: 100%;
    top: 50%;
    text-align: center;
}

.select-all-btn {
    font-weight: bold;
    color: #366ba0;
    cursor: pointer;
}

.labeled-multi-select-header {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
}

.darkBG {
    background-color: rgba(0, 0, 0, 0.2);
    width: 100vw;
    height: 100vh;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
}

.modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 25rem;
    height: 12rem;
    background: white;
    color: white;
    z-index: 100;
    border-radius: 8px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
}

.modalHeader {
    height: 4rem;
    background: white;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.heading {
    margin: 2rem;
    color: #2c3e50;
    font-weight: 500;
    font-size: 18px;
    text-align: left;
}

.modalContent {
    font-size: 15px;
    color: #2c3e50;
    text-align: left;
    margin: 1rem 2rem;
}

.close {
    position: absolute;
    right: 1rem;
    top: 1rem;
    width: 2rem;
    height: 1.5rem;
    opacity: 0.3;
}
.close:hover {
    opacity: 1;
}
.close:before, .close:after {
    position: absolute;
    left: 1rem;
    content: ' ';
    height: 1.5rem;
    width: 2px;
    background-color: #333;
}
.close:before {
    transform: rotate(45deg);
}
.close:after {
    transform: rotate(-45deg);
}`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;AACzB;;AAEA;;;;;;CAMC;AACD;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iIAAiI;AACrI;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,sEAAsE;IACtE,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;EAgBE;;AAEF;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;aACS;AACb;;AAEA;IACI;aACS;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI;QACI,+BAA+B;IACnC;IACA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B","sourcesContent":["\n.Toastify__toast-body {\n    white-space: pre-line;\n}\n\n/*\nmain {\n    grid-area: main;\n    max-width: 100%;\n    overflow: hidden;\n}\n*/\nbutton {\n    background-color: #366ba0;\n    color: white;\n    padding: .375rem .75rem;\n    border: 1px solid transparent;\n    display: inline-block;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: .25rem;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\nbutton:hover {\n    background-color: #2b5580;\n    border-color: #2b5580;\n}\n\nselect {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: .25rem;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    margin-bottom: 1rem;\n}\n\n/*input {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: .25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    box-sizing: border-box;\n    margin-bottom: 1rem;\n}*/\n\nlabel select,input {\n    margin-top: 0.5rem;\n}\nlabel {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n}\n\ntable {\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #212529;\n    border-spacing: 0;\n}\n\ntable tbody tr:hover {\n    color: #212529;\n    background-color: rgba(0,0,0,.075);\n}\n\ntable td:not(.expanded), table th:not(.search) {\n    padding: .75rem;\n    vertical-align: top;\n    text-align: left;\n}\n\n.table-header {\n    display: table-cell;\n}\n\n.change-type-selector {\n    margin-bottom: 1rem;\n}\n\n.editor {\n    margin-bottom: 1rem;\n    border: 1px solid #ddd;\n}\n\n.editor .CodeMirror {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.editor .CodeMirror pre.CodeMirror-line {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.launchnotes-widget .announcement-card-wrapper .announcement-card .categories {\n  line-height: 0.5;\n}\n\n.loader {\n    text-align: center;\n    transition: width 2s;\n}\n\n.loader.button {\n    display: inline;\n    padding-left: 18px;\n    padding-right: 18px;\n}\n\n.loader:not(.button) {\n    font-size: 62px;\n    color: #366ba0;\n}\n\n.loader i {\n    -webkit-animation: spin 2s linear infinite;\n    /* Safari */\n    animation: spin 2s linear infinite;\n}\n\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.loader-page {\n    position: fixed;\n    width: 100%;\n    top: 50%;\n    text-align: center;\n}\n\n.select-all-btn {\n    font-weight: bold;\n    color: #366ba0;\n    cursor: pointer;\n}\n\n.labeled-multi-select-header {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n}\n\n.darkBG {\n    background-color: rgba(0, 0, 0, 0.2);\n    width: 100vw;\n    height: 100vh;\n    z-index: 0;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    position: absolute;\n}\n\n.modal {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 25rem;\n    height: 12rem;\n    background: white;\n    color: white;\n    z-index: 100;\n    border-radius: 8px;\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n}\n\n.modalHeader {\n    height: 4rem;\n    background: white;\n    overflow: hidden;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n}\n\n.heading {\n    margin: 2rem;\n    color: #2c3e50;\n    font-weight: 500;\n    font-size: 18px;\n    text-align: left;\n}\n\n.modalContent {\n    font-size: 15px;\n    color: #2c3e50;\n    text-align: left;\n    margin: 1rem 2rem;\n}\n\n.close {\n    position: absolute;\n    right: 1rem;\n    top: 1rem;\n    width: 2rem;\n    height: 1.5rem;\n    opacity: 0.3;\n}\n.close:hover {\n    opacity: 1;\n}\n.close:before, .close:after {\n    position: absolute;\n    left: 1rem;\n    content: ' ';\n    height: 1.5rem;\n    width: 2px;\n    background-color: #333;\n}\n.close:before {\n    transform: rotate(45deg);\n}\n.close:after {\n    transform: rotate(-45deg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
